import { render, staticRenderFns } from "./Faculty.vue?vue&type=template&id=15d0377a&"
import script from "./Faculty.vue?vue&type=script&lang=js&"
export * from "./Faculty.vue?vue&type=script&lang=js&"
import style0 from "./Faculty.vue?vue&type=style&index=0&id=15d0377a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports